import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_11: FaireProductEntity = {
  token: "sweet-wink-11",
  type: "product",
  name: "Boo Bows Halloween Clip Set - Hair Bows",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/1d188994c51c7df970a828a6e9bcaebc915c9e7135d15836ebb9302575cfdd1f.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&width=720",
  priceDollars: 10,
  msrpDollars: 20,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_apparel-baby"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
